exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mw-visualization-tooltip__point-hover {\n  background-color: #E0E0E0;\n}\n.mw-visualization-tooltip__point {\n  padding: 4px;\n}", ""]);
